export default "__VITE_ASSET__BWck16u$__"